import React, { Component } from "react";
import { ajaxManage } from "utils/common";
import { Table, Divider, message } from 'antd';

const { Column } = Table;

class App extends Component {

	operate = (accountId) => {
		if(!accountId){
			message.destroy();
			message.error("账号无效！");
			return false;
		}
		ajaxManage({
			url: "/schedule/operate",
			data: {
				accountId: accountId
			}
		}).then(res => {
			message.destroy();
			message.success("同步成功！");
		}).catch(err => {
			message.destroy();
			message.error("同步失败！");
		})
	}

	showVideo = (accountId) => {
		if(!accountId){
			message.destroy();
			message.error("账号无效！");
			return false;
		}
		window.open(location.origin + "/result?accountId=" + accountId);
	}

  	render() {
  		const { pageData, pagination, handleTableChange } = this.props;

    	return (
    		<Table dataSource={pageData}
    			align="center"
    			scroll={{x: 2600}}
    			pagination={pagination}
    			onChange={handleTableChange}
    			rowKey={record => record.id}
    			className="list-table"
    		>
			    <Column
		        	title="code"
		        	width="120px"
		        	align="center"
		        	dataIndex="corpCode"
		      	/>
			    <Column
			      	title="候选人姓名"
		        	width="120px"
		        	align="center"
			      	dataIndex="userName"
			    />
			    <Column
		        	title="externalkey"
		        	width="260px"
		        	align="center"
		        	dataIndex="externalKey"
		      	/>
			    <Column
			      	title="视频时长"
		        	width="100px"
		        	align="center"
			      	dataIndex="totalFileDuration"
			      	sorter={(a, b) => a.totalFileSize - b.totalFileSize}
			    />
			    <Column
		        	title="视频大小"
		        	width="100px"
		        	align="center"
		        	dataIndex="totalFileSize"
			      	sorter={(a, b) => a.totalFileSize - b.totalFileSize}
		      	/>
			    <Column
			      	title="录制状态"
		        	width="100px"
		        	align="center"
			      	dataIndex="status"
			      	render={(text, record) => {
  						if(text === 0){
			      			return "未开始";
			      		}else if(text === 1){
			      			return "已完成";
			      		}else if(text === 2){
			      			return "进行中";
			      		}else if(text === 5){
			      			return "账号无效";
			      		}else{
			      			return text;
			      		}
			      	}}
			    />
			    <Column
		        	title="提交情况"
		        	width="100px"
		        	align="center"
		        	dataIndex="submitStatus"
			      	render={(text, record) => {
			      		if(text === 1){
			      			return "次数耗尽";
			      		}else if(text === 2){
			      			return "过期未提交";
			      		}else if(text === 3){
			      			return "过期未开始";
			      		}else if(text === 4){
			      			return "完整提交";
			      		}else{
			      			return text;
			      		}
			      	}}
		      	/>
			    <Column
			      	title="交卷时间"
		        	width="200px"
		        	align="center"
			      	dataIndex="finishTime"
			      	sorter={(a, b) => new Date(a.finishTime) - new Date(b.totalFileSize)}
			    />
			    <Column
			      	title="视频文件状态"
		        	width="160px"
		        	align="center"
			      	dataIndex="fileStatus"
			      	render={(text, record) => 
			      		text === 1?
			      		"不存在":
			      		(text === 0?"存在":null)
			      	}
			    />
			    <Column
		        	title="视频来源"
		        	width="100px"
		        	align="center"
		        	dataIndex="videoResource"
			      	render={(text, record) => 
			      		text == 1?
			      		"小程序":
			      		(text == 2?"PC":null)
			      	}
		      	/>
			    <Column
			      	title="面试开始时间"
		        	width="200px"
		        	align="center"
			      	dataIndex="startTimeStr"
			      	sorter={(a, b) => new Date(a.startTimeStr) - new Date(b.startTimeStr)}
			    />
			    <Column
			      	title="面试结束时间"
		        	width="200px"
		        	align="center"
			      	dataIndex="endTimeStr"
			      	sorter={(a, b) => new Date(a.endTimeStr) - new Date(b.endTimeStr)}
			    />
			    <Column
			      	title="共享费用账户"
		        	width="160px"
		        	align="center"
			      	dataIndex="paidAccountId"
			    />
			    <Column
			      	title="所属机构"
		        	width="160px"
		        	align="center"
			      	dataIndex="orgName"
			    />
			    <Column
			      	title="已完成同步成功"
		        	width="180px"
		        	align="center"
			      	dataIndex="finishSyncStatus"
			      	render={(text, record) => 
			      		text === 0?
			      		"是":
			      		(text === 1?"否":null)
			      	}
			    />
		    	<Column
			      	title="操作"
		        	width="160px"
			      	fixed="right"
		        	align="center"
			      	dataIndex="operate"
			      	render={(text, record) => (
			        	<span>
			          		{
			          			record.status === 1?
			          			<a href="javascript:;" onClick={() => this.showVideo(record.accountId)}>看视频</a>:
			          			null
			          		}
			          		{
			          			record.status === 1 && record.finishSyncStatus === 1?
			          			<Divider type="vertical" />:null
			          		}
			          		{
			          			record.finishSyncStatus === 1?
			          			<a href="javascript:;" onClick={() => this.operate(record.accountId)}>再次同步</a>:
			          			null
			          		}
			        	</span>
		        	)}
			    />
		  	</Table>
		);
	}
}

export default App;